<div class="dropdown" [class.is-active]="isDropdownOpen()" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()"
    (click)="$event.stopPropagation()">
    <div class="dropdown-trigger">
        <button class="button is-info is-rounded is-outlined" aria-haspopup="true" (click)="isDropdownOpen.set(true)">
            <span class="icon">
                <i class="ri-notification-3-line"></i>
            </span>
            @if(unreadCount() > 0) {
            <span class="tag is-danger is-rounded is-small">{{ unreadCount() }}</span>
            }
        </button>
    </div>

    @if(isDropdownOpen()) {
    <div class="dropdown-menu" role="menu" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
        <div class="dropdown-content notification-content">
            <div class="notification-header px-5 py-4 is-flex is-justify-content-space-between is-align-items-center"
                style="border-bottom: 1px solid #eaecf0;">
                <h3 class="title is-6 mb-0">{{ 'notifications.title' | translate }}</h3>
            </div>

            <div class="notification-body">
            @if(isLoading()) {
            <div class="is-flex is-justify-content-center is-align-items-center py-6">
                <div class="loader is-loading" style="width: 2rem; height: 2rem;"></div>
            </div>
            } @else if(unreadNotifications().length > 0) {
            @for(notification of unreadNotifications(); track notification.id) {
            <div class="notification-item px-5 py-4" (click)="openDetailModal(notification)" style="cursor: pointer;">
                <div class="is-flex is-align-items-center is-gap-2">
                    <div class="is-flex is-justify-content-center is-align-items-center notification-icon"
                        [class]="notification.priority | notificationTypeIconBackgroundPipe"
                        style="height: 40px; width: 40px; border-radius: 8px; flex-shrink: 0;">
                        <div class="icon">
                            <i class="has-text-white" [class]="notification.type | notificationTypeIconPipe"></i>
                        </div>
                    </div>
                    <div class="is-flex-grow-1 is-flex is-flex-direction-column">
                        <div>
                            <div class="is-flex is-justify-content-space-between is-gap-2">
                                <p class="title is-7 mb-0">{{ notification.title }}</p>
                                <span class="is-size-7 has-text-grey" style="flex-shrink: 0;">{{ getTimeAgo(notification.createdAt) }}</span>
                            </div>
                            <p class="is-size-7 has-text-grey mb-2">{{ 'NotificationType.' + notification.type | translate | uppercase }}</p>
                        </div>
                    </div>
                    <button class="button is-info is-outlined notification-action-btn"
                        (click)="markAsRead(notification.id, $event)"
                        title="Mark as read"
                        style="flex-shrink: 0;">
                        <span class="icon is-small">
                            <i class="ri-check-line"></i>
                        </span>
                    </button>
                </div>
            </div>
            }
            } @else {
            <div class="has-text-centered py-6">
                <p class="icon is-large has-text-grey-light">
                    <i class="ri-notification-off-line ri-2x"></i>
                </p>
                <p class="is-size-7 has-text-grey mt-3">{{ 'notifications.noUnreadNotifications' | translate }}</p>
            </div>
            }
            </div>
            <div class="notification-footer px-5 py-3 has-text-centered" style="border-top: 1px solid #f0f0f0;">
                <button class="button is-ghost is-small is-fullwidth" (click)="viewAllNotifications()">
                    {{ 'notifications.viewAll' | translate }}
                </button>
            </div>
        </div>
    </div>
    }
</div>

<!-- Notification Details Modal -->
@if(selectedNotification()) {
<app-notification-details-modal [(isOpen)]="isDetailModalOpen" [notification]="selectedNotification()!" (notificationChange)="onDetailModalNotificationUpdate($event)" />
}